
import { defineComponent } from 'vue'

import Header from '@/components/Home/Header.vue'
import MealManagement from '@/components/Home/MealManagement.vue'
import MealInput from '@/components/Home/MealInput.vue'
import Demo1 from '@/components/Home/Demo1.vue'
import Demo2 from '@/components/Home/Demo2.vue'
import Demo3 from '@/components/Home/Demo3.vue'
import Demo4 from '@/components/Home/Demo4.vue'
import Statistics from '@/components/Home/Statistics.vue'

import setMeta from '@/scripts/root/setMeta'

export default defineComponent({
  components: {
    Header,
    MealManagement,
    MealInput,
    Demo1,
    Demo2,
    Demo3,
    Demo4,
    Statistics,
  },
  computed: {
    isMainRoute(): boolean {
      // 정책 페이지가 아닌 경우에만 홈 컨텐츠를 표시
      return !(
        this.$route.path.includes('privacy-policy') ||
        this.$route.path.includes('terms-of-use') ||
        this.$route.path.includes('cookie-policy')
      )
    },
  },
  created() {
    // 앱의 전체 타이틀(탭바 타이틀)
    // 탭바의 이미지를 변경하고 싶은 경우, favicon을 수정.
    setMeta(document)
  },
})
